/* tslint:disable */
/* eslint-disable */
/**
 * Donio
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProjectAnalytics } from './ProjectAnalytics';
import {
    ProjectAnalyticsFromJSON,
    ProjectAnalyticsFromJSONTyped,
    ProjectAnalyticsToJSON,
    ProjectAnalyticsToJSONTyped,
} from './ProjectAnalytics';
import type { ProjectTaxonomy } from './ProjectTaxonomy';
import {
    ProjectTaxonomyFromJSON,
    ProjectTaxonomyFromJSONTyped,
    ProjectTaxonomyToJSON,
    ProjectTaxonomyToJSONTyped,
} from './ProjectTaxonomy';
import type { ProjectDonationAmount } from './ProjectDonationAmount';
import {
    ProjectDonationAmountFromJSON,
    ProjectDonationAmountFromJSONTyped,
    ProjectDonationAmountToJSON,
    ProjectDonationAmountToJSONTyped,
} from './ProjectDonationAmount';

/**
 * 
 * @export
 * @interface ProjectSettings
 */
export interface ProjectSettings {
    /**
     * 
     * @type {string}
     * @memberof ProjectSettings
     */
    mode: ProjectSettingsModeEnum;
    /**
     * 
     * @type {string}
     * @memberof ProjectSettings
     */
    modeGroup: ProjectSettingsModeGroupEnum;
    /**
     * 
     * @type {string}
     * @memberof ProjectSettings
     */
    urlType: ProjectSettingsUrlTypeEnum;
    /**
     * Amounts used in the donation form for Dobro projects. For Plus projects, it is zero because rewards are used here..
     * @type {Array<ProjectDonationAmount>}
     * @memberof ProjectSettings
     */
    donationAmounts: Array<ProjectDonationAmount> | null;
    /**
     * Is the project the good habit source project, where donations are collected before allocation?
     * @type {boolean}
     * @memberof ProjectSettings
     */
    isGoodHabit: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectSettings
     */
    isLongTerm: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectSettings
     */
    hasTipsDisabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectSettings
     */
    hasPhoneNumberRequired: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectSettings
     */
    isHidden: boolean;
    /**
     * 
     * @type {ProjectTaxonomy}
     * @memberof ProjectSettings
     */
    taxonomy: ProjectTaxonomy;
    /**
     * 
     * @type {ProjectAnalytics}
     * @memberof ProjectSettings
     */
    analytics: ProjectAnalytics;
}


/**
 * @export
 */
export const ProjectSettingsModeEnum = {
    NadacniFond: 'nadacni-fond',
    NadacniFondDobrozvyk: 'nadacni-fond-dobrozvyk',
    VerejnaSbirka: 'verejna-sbirka',
    VerejnaSbirkaVol2: 'verejna-sbirka-vol-2',
    NfDobrosti: 'nf-dobrosti',
    DonioPlus: 'donio-plus',
    DonioSk: 'donio-sk',
    SkDobrozvyk: 'sk-dobrozvyk'
} as const;
export type ProjectSettingsModeEnum = typeof ProjectSettingsModeEnum[keyof typeof ProjectSettingsModeEnum];

/**
 * @export
 */
export const ProjectSettingsModeGroupEnum = {
    Dobro: 'dobro',
    Plus: 'plus'
} as const;
export type ProjectSettingsModeGroupEnum = typeof ProjectSettingsModeGroupEnum[keyof typeof ProjectSettingsModeGroupEnum];

/**
 * @export
 */
export const ProjectSettingsUrlTypeEnum = {
    Classic: 'classic',
    Fancy: 'fancy'
} as const;
export type ProjectSettingsUrlTypeEnum = typeof ProjectSettingsUrlTypeEnum[keyof typeof ProjectSettingsUrlTypeEnum];


/**
 * Check if a given object implements the ProjectSettings interface.
 */
export function instanceOfProjectSettings(value: object): value is ProjectSettings {
    if (!('mode' in value) || value['mode'] === undefined) return false;
    if (!('modeGroup' in value) || value['modeGroup'] === undefined) return false;
    if (!('urlType' in value) || value['urlType'] === undefined) return false;
    if (!('donationAmounts' in value) || value['donationAmounts'] === undefined) return false;
    if (!('isGoodHabit' in value) || value['isGoodHabit'] === undefined) return false;
    if (!('isLongTerm' in value) || value['isLongTerm'] === undefined) return false;
    if (!('hasTipsDisabled' in value) || value['hasTipsDisabled'] === undefined) return false;
    if (!('hasPhoneNumberRequired' in value) || value['hasPhoneNumberRequired'] === undefined) return false;
    if (!('isHidden' in value) || value['isHidden'] === undefined) return false;
    if (!('taxonomy' in value) || value['taxonomy'] === undefined) return false;
    if (!('analytics' in value) || value['analytics'] === undefined) return false;
    return true;
}

export function ProjectSettingsFromJSON(json: any): ProjectSettings {
    return ProjectSettingsFromJSONTyped(json, false);
}

export function ProjectSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'mode': json['mode'],
        'modeGroup': json['modeGroup'],
        'urlType': json['urlType'],
        'donationAmounts': (json['donationAmounts'] == null ? null : (json['donationAmounts'] as Array<any>).map(ProjectDonationAmountFromJSON)),
        'isGoodHabit': json['isGoodHabit'],
        'isLongTerm': json['isLongTerm'],
        'hasTipsDisabled': json['hasTipsDisabled'],
        'hasPhoneNumberRequired': json['hasPhoneNumberRequired'],
        'isHidden': json['isHidden'],
        'taxonomy': ProjectTaxonomyFromJSON(json['taxonomy']),
        'analytics': ProjectAnalyticsFromJSON(json['analytics']),
    };
}

export function ProjectSettingsToJSON(json: any): ProjectSettings {
    return ProjectSettingsToJSONTyped(json, false);
}

export function ProjectSettingsToJSONTyped(value?: ProjectSettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mode': value['mode'],
        'modeGroup': value['modeGroup'],
        'urlType': value['urlType'],
        'donationAmounts': (value['donationAmounts'] == null ? null : (value['donationAmounts'] as Array<any>).map(ProjectDonationAmountToJSON)),
        'isGoodHabit': value['isGoodHabit'],
        'isLongTerm': value['isLongTerm'],
        'hasTipsDisabled': value['hasTipsDisabled'],
        'hasPhoneNumberRequired': value['hasPhoneNumberRequired'],
        'isHidden': value['isHidden'],
        'taxonomy': ProjectTaxonomyToJSON(value['taxonomy']),
        'analytics': ProjectAnalyticsToJSON(value['analytics']),
    };
}

